export default {
    mounted() {
        const s = this.$socket
        if (!s || !this.$options.sockets) return
        this.__so_handlers = []
        for (const [event, handler] of Object.entries(this.$options.sockets)) {
            const fn = handler.bind(this)
            s.on(event, fn)
            this.__so_handlers.push([event, fn])
        }
    },
    beforeUnmount() {
        const s = this.$socket
        if (!s || !this.__so_handlers) return
        for (const [event, fn] of this.__so_handlers) s.off(event, fn)
    }
}